export {default as all} from './all'
export {default as details} from './details'
